import React from 'react'
import {Link} from 'react-router-dom';

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      history: false,
      comments: false,
      responsive: false,
      responsiveMode: false
    }
  }

  toggleHistory() {
    this.setState({
      history: !this.state.history,
      comments: false,
      responsive: false
    })
  }

  toggleResponsive() {
    this.setState({
      history: false,
      comments: false,
      responsive: !this.state.responsive
    })
  }

  toggleComments() {
    this.setState({
      history: false,
      comments: !this.state.comments,
      responsive: false
    })
  }

  handleSelectAction(index) {
    this.props.onSelectAction(index)
  }

  handleSelectComment(id) {
    this.props.onSelectComment(id)
  }

  handleSelectResponsive(mode) {
    if(mode === this.state.responsiveMode) {
      mode = false
    }
    this.setState({
      responsiveMode: mode
    })
    this.props.onSelectResponsiveMode(mode)
  }

  render() {
    const {
      title = ''
    } = this.props.settings

    var selectedActionIndex = -1
    var actions = []
    if(this.props.actions.length > 1) {
      this.props.actions.forEach((action, i) => {
        if(i > 0) {
          if(action.selected) {
            selectedActionIndex = i - 1
          }
          actions.push(action)
        }
      })
    }
    return(
      <div id="editor-header">
        <Link
          to={'/' + (this.props.type === 'wbt' ? 'wbts' : '') + (this.props.type === 'wbt_template' ? 'vorlagen' : '')}
          className="button highlighted menu"
        >
          <div className="icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Link>
        <div className="wbt-title">{title}</div>
        <div className="action-bar">
          <div className="quick-actions">
            <div className="quick-actions-item">
              <button
                className={'quick-action-button history' + (this.state.history ? ' active' : '')}
                onClick={this.toggleHistory.bind(this)}
              >
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19.297" viewBox="0 0 21 19.297">
                    <path d="M24.351,16a9.655,9.655,0,0,0-9.578,8.514H13l2.27,2.838,2.27-2.838H15.918a8.5,8.5,0,1,1,1.162,5.569l-.931.639A9.647,9.647,0,1,0,24.351,16Zm-.568,5.108v4.807l.213.177,3.281,2.625.709-.887-.443-.355-2.625-2.1V21.108" transform="translate(-13 -16)" />
                  </svg>
                </div>
              </button>
              {
                this.state.history ?
                  <div className="quick-actions-window">
                    <div className="headline">Aktionen</div>
                    <ul className="actions">
                      {
                        actions.map((action, index) => {
                          return(
                            <li
                              key={index}
                            >
                              <button
                                className={(selectedActionIndex > index ? ' inactive' : '') + (selectedActionIndex === index ? ' active' : '')}
                                onClick={this.handleSelectAction.bind(this, index)}
                              >
                                <span className="label">{action.label}</span>
                                <span className="icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="9.14" viewBox="0 0 18 9.14">
                                    <path d="M15.212,25.777H13.435l-1.9,2.209c-.076.076-.127.153-.2.228a.345.345,0,0,0-.076.1c-.2.228-.381.432-.584.66a7.866,7.866,0,0,1,.584.71,1.328,1.328,0,0,0,.253.279h-.025l1.3,1.5c.2.228.381.457.584.685l.076.076h1.777l-2.183-2.538-.508-.584.508.584c4.088.025,8.2.025,12.313.051a2.119,2.119,0,0,1,1.422.635,1.889,1.889,0,0,1,.559,1.32v.1a1.873,1.873,0,0,1-.508,1.142,2.031,2.031,0,0,1-1.167.635H19v1.346h6.854a3.525,3.525,0,0,0,1.955-1.067,3.2,3.2,0,0,0,.863-1.98v-.178a3.256,3.256,0,0,0-.939-2.26,3.336,3.336,0,0,0-2.336-1.041h-.05c-4.113-.025-8.2-.025-12.313-.051l2.181-2.564" transform="translate(-10.668 -25.777)" fill="#fff" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                :
                  null
              }
            </div>
            <div className="quick-actions-item">
              <button
                className={'quick-action-button responsive' + (this.state.responsive ? ' active' : '')}
                onClick={this.toggleResponsive.bind(this)}
              >
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.261" height="20" viewBox="0 0 22.261 20">
                    <g id="computer" transform="translate(0 -26)">
                      <path d="M20.63,26h-19A1.632,1.632,0,0,0,0,27.63v13.7a1.632,1.632,0,0,0,1.63,1.63H8.263L7.871,44.33a1.507,1.507,0,0,1-1.349,1.018H4.391a.326.326,0,1,0,0,.652H17.87a.326.326,0,1,0,0-.652h-2.13A1.507,1.507,0,0,1,14.39,44.33L14,42.957H20.63a1.632,1.632,0,0,0,1.63-1.63V27.63A1.632,1.632,0,0,0,20.63,26ZM13.763,44.509a1.99,1.99,0,0,0,.5.838H8a1.99,1.99,0,0,0,.5-.838l.444-1.553h4.378Zm7.846-3.183a.979.979,0,0,1-.978.978h-19a.979.979,0,0,1-.978-.978V27.63a.979.979,0,0,1,.978-.978h19a.979.979,0,0,1,.978.978Z" transform="translate(0 0)" />
                      <path d="M49.652,68.717V56.326A.326.326,0,0,0,49.326,56h-19a.326.326,0,0,0-.326.326V61.87a.326.326,0,0,0,.652,0V56.652H49V68.391H30.652V63.174a.326.326,0,1,0-.652,0v5.543a.326.326,0,0,0,.326.326h19A.326.326,0,0,0,49.652,68.717Z" transform="translate(-28.696 -28.696)" />
                      <circle cx="0.326" cy="0.326" r="0.326" transform="translate(20.334 40.999)" />
                      <circle cx="0.326" cy="0.326" r="0.326" transform="translate(19.03 40.999)" />
                    </g>
                  </svg>
                </div>
              </button>
              {
                this.state.responsive ?
                  <div className="quick-actions-window">
                    <div className="headline">Responsive</div>
                    <ul className="responsive">
                      <li>
                        <button
                          className={this.state.responsiveMode === 'desktop' ? ' active' : ''}
                          onClick={this.handleSelectResponsive.bind(this, 'desktop')}
                        >
                          <span className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.375" viewBox="0 0 16 14.375">
                              <path d="M14.828,26H1.172A1.173,1.173,0,0,0,0,27.172v9.844a1.173,1.173,0,0,0,1.172,1.172H5.939l-.282.987a1.083,1.083,0,0,1-.97.731H3.156a.234.234,0,0,0,0,.469h9.687a.234.234,0,1,0,0-.469H11.313a1.083,1.083,0,0,1-.97-.731l-.282-.987h4.767A1.173,1.173,0,0,0,16,37.016V27.172A1.173,1.173,0,0,0,14.828,26ZM9.892,39.3a1.43,1.43,0,0,0,.36.6h-4.5a1.43,1.43,0,0,0,.36-.6l.319-1.116H9.573Zm5.639-2.288a.7.7,0,0,1-.7.7H1.172a.7.7,0,0,1-.7-.7V27.172a.7.7,0,0,1,.7-.7H14.828a.7.7,0,0,1,.7.7Z" transform="translate(0 -26)" />
                            </svg>
                          </span>
                          <span className="label">Desktop</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className={this.state.responsiveMode === 'laptop' ? ' active' : ''}
                          onClick={this.handleSelectResponsive.bind(this, 'laptop')}
                        >
                          <span className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9.006" viewBox="0 0 16 9.006">
                              <g transform="translate(-18.041 -32)">
                                <path d="M33.79,39.5h-.75V32.25a.236.236,0,0,0-.25-.25H19.281a.236.236,0,0,0-.25.25V39.5h-.75a.218.218,0,0,0-.225.15.272.272,0,0,0,.05.276l1,1a.227.227,0,0,0,.175.075H32.789a.227.227,0,0,0,.175-.075l1-1a.229.229,0,0,0,.05-.276.24.24,0,0,0-.225-.15Zm-14.258-7H32.539v7H19.531Zm13.158,8H19.381l-.5-.5H33.189Z" transform="translate(0)" />
                                <path d="M47.251,36h-2a.25.25,0,1,0,0,.5h2a.25.25,0,1,0,0-.5Z" transform="translate(-20.216 -2.999)" />
                              </g>
                            </svg>

                          </span>
                          <span className="label">Laptop</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className={this.state.responsiveMode === 'tablet' ? ' active' : ''}
                          onClick={this.handleSelectResponsive.bind(this, 'tablet')}
                        >
                          <span className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.578" viewBox="0 0 14 10.578">
                              <path d="M16.933,5A.938.938,0,0,0,16,5.933V18.067a.938.938,0,0,0,.933.933h8.711a.938.938,0,0,0,.933-.933V5.933A.938.938,0,0,0,25.644,5Zm0,.622h8.711a.3.3,0,0,1,.311.311v.311H16.622V5.933A.3.3,0,0,1,16.933,5.622Zm-.311,1.244h9.333v9.644H16.622Zm0,10.267h9.333v.933a.3.3,0,0,1-.311.311H16.933a.3.3,0,0,1-.311-.311Zm4.667.311a.311.311,0,1,0,.311.311A.311.311,0,0,0,21.289,17.444Z" transform="translate(19 -16) rotate(90)" />
                            </svg>
                          </span>
                          <span className="label">Tablet</span>
                        </button>
                      </li>
                      <li>
                        <button
                          className={this.state.responsiveMode === 'mobile' ? ' active' : ''}
                          onClick={this.handleSelectResponsive.bind(this, 'mobile')}
                        >
                          <span className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8.24" height="14.1" viewBox="0 0 8.24 14.1">
                              <path d="M25.814,7A.816.816,0,0,0,25,7.814V20.186a.816.816,0,0,0,.814.814h6.512a.816.816,0,0,0,.814-.814V7.814A.816.816,0,0,0,32.326,7Zm0,.326h6.512a.484.484,0,0,1,.488.488V8.3H25.326V7.814A.484.484,0,0,1,25.814,7.326Zm-.488,1.3h7.488V18.07H25.326Zm0,9.767h7.488v1.791a.484.484,0,0,1-.488.488H25.814a.484.484,0,0,1-.488-.488Zm3.744.488a.651.651,0,1,0,.651.651A.653.653,0,0,0,29.07,18.884Zm0,.326a.326.326,0,1,1-.326.326A.323.323,0,0,1,29.07,19.209Z" transform="translate(-24.95 -6.95)" strokeWidth="0.1" stroke="#fff" />
                            </svg>
                          </span>
                          <span className="label">Mobile</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                :
                  null
              }
            </div>
            <div className="quick-actions-item">
              <button
                className="quick-action-button settings"
                onClick={this.props.onOpenSettings}
              >
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.612" height="18.612" viewBox="0 0 18.612 18.612">
                    <g transform="translate(0 0)">
                      <path d="M9.89,18.612H8.722A1.715,1.715,0,0,1,7.009,16.9v-.4a7.514,7.514,0,0,1-1.167-.484l-.28.28a1.713,1.713,0,0,1-2.423,0l-.826-.826a1.713,1.713,0,0,1,0-2.423l.28-.28A7.514,7.514,0,0,1,2.109,11.6h-.4A1.715,1.715,0,0,1,0,9.89V8.722A1.715,1.715,0,0,1,1.713,7.009h.4a7.516,7.516,0,0,1,.484-1.167l-.28-.28a1.713,1.713,0,0,1,0-2.423l.826-.826a1.713,1.713,0,0,1,2.423,0l.28.28a7.521,7.521,0,0,1,1.167-.484v-.4A1.715,1.715,0,0,1,8.722,0H9.89A1.715,1.715,0,0,1,11.6,1.713v.4a7.514,7.514,0,0,1,1.167.484l.28-.28a1.713,1.713,0,0,1,2.423,0l.826.826a1.713,1.713,0,0,1,0,2.423l-.28.28A7.515,7.515,0,0,1,16.5,7.009h.4a1.715,1.715,0,0,1,1.713,1.713V9.89A1.715,1.715,0,0,1,16.9,11.6h-.4a7.516,7.516,0,0,1-.484,1.167l.28.28a1.713,1.713,0,0,1,0,2.423l-.826.826a1.713,1.713,0,0,1-2.423,0l-.28-.28A7.521,7.521,0,0,1,11.6,16.5v.4A1.715,1.715,0,0,1,9.89,18.612ZM6.024,14.874a6.428,6.428,0,0,0,1.666.692.545.545,0,0,1,.409.528V16.9a.624.624,0,0,0,.623.623H9.89a.624.624,0,0,0,.623-.623v-.805a.545.545,0,0,1,.409-.528,6.427,6.427,0,0,0,1.666-.692.545.545,0,0,1,.663.084l.57.57a.623.623,0,0,0,.881,0l.826-.826a.623.623,0,0,0,0-.881l-.571-.571a.545.545,0,0,1-.084-.663,6.426,6.426,0,0,0,.692-1.666.545.545,0,0,1,.528-.409H16.9a.624.624,0,0,0,.623-.623V8.722A.624.624,0,0,0,16.9,8.1h-.805a.545.545,0,0,1-.528-.409,6.428,6.428,0,0,0-.692-1.666.545.545,0,0,1,.084-.663l.57-.57a.623.623,0,0,0,0-.881L14.7,3.084a.623.623,0,0,0-.881,0l-.571.571a.545.545,0,0,1-.663.084,6.427,6.427,0,0,0-1.666-.692.545.545,0,0,1-.409-.528V1.713a.624.624,0,0,0-.623-.623H8.722a.624.624,0,0,0-.623.623v.805a.545.545,0,0,1-.409.528,6.427,6.427,0,0,0-1.666.692.545.545,0,0,1-.663-.084l-.57-.57a.623.623,0,0,0-.881,0l-.826.826a.623.623,0,0,0,0,.881l.571.571a.545.545,0,0,1,.084.663A6.426,6.426,0,0,0,3.047,7.69a.545.545,0,0,1-.528.409H1.713a.624.624,0,0,0-.623.623V9.89a.624.624,0,0,0,.623.623h.805a.545.545,0,0,1,.528.409,6.428,6.428,0,0,0,.692,1.666.545.545,0,0,1-.084.663l-.57.57a.623.623,0,0,0,0,.881l.826.826a.623.623,0,0,0,.881,0l.571-.571a.548.548,0,0,1,.663-.084Z" />
                      <path d="M148.65,152.7a4.05,4.05,0,1,1,4.05-4.05A4.054,4.054,0,0,1,148.65,152.7Zm0-7.009a2.959,2.959,0,1,0,2.959,2.959A2.962,2.962,0,0,0,148.65,145.691Z" transform="translate(-139.343 -139.343)" />
                    </g>
                  </svg>
                </div>
              </button>
            </div>
            <div className="quick-actions-item">
              <button
                className={'quick-action-button preview' + (this.props.previewMode ? ' active' : '')}
                onClick={this.props.onTogglePreviewMode}
              >
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25.104" height="14.645" viewBox="0 0 25.104 14.645">
                    <g transform="translate(0 -106.662)">
                      <g transform="translate(0 106.662)">
                        <g transform="translate(0 0)">
                          <path d="M25.012,113.687c-.2-.288-4.949-7.025-12.459-7.025-6.445,0-12.187,6.7-12.429,6.984a.525.525,0,0,0,0,.676c.242.286,5.984,6.984,12.429,6.984s12.187-6.7,12.429-6.984A.523.523,0,0,0,25.012,113.687Zm-12.459,6.573c-5.166,0-10.079-4.927-11.326-6.276,1.246-1.35,6.153-6.276,11.326-6.276,6.045,0,10.312,4.92,11.354,6.248C22.7,115.263,17.763,120.261,12.552,120.261Z" transform="translate(0 -106.662)" />
                        </g>
                      </g>
                      <g transform="translate(8.368 109.8)">
                        <g transform="translate(0 0)">
                          <path d="M174.846,170.662a4.184,4.184,0,1,0,4.184,4.184A4.188,4.188,0,0,0,174.846,170.662Zm0,7.322a3.138,3.138,0,1,1,3.138-3.138A3.142,3.142,0,0,1,174.846,177.984Z" transform="translate(-170.662 -170.662)" />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </button>
            </div>
            {
              this.props.type === 'wbt' ?
                <div className="quick-actions-item">
                  <button
                    className="quick-action-button templates"
                    onClick={this.props.onAddTemplate}
                  >
                    <div className="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19.031" height="19.031" viewBox="0 0 19.031 19.031">
                        <g>
                          <path d="M17.5.12h-16A1.43,1.43,0,0,0,.12,1.53v16a1.42,1.42,0,0,0,1.41,1.41h16a1.41,1.41,0,0,0,1.41-1.41v-16A1.42,1.42,0,0,0,17.5.12ZM18,1.53v6.1H8.58V1.06H17.5a.47.47,0,0,1,.47.47Zm-16.9,16v-16a.47.47,0,0,1,.47-.47h6.1V18H1.54a.47.47,0,0,1-.48-.46h0ZM17.5,18H8.58V8.58H18V17.5a.47.47,0,0,1-.47.47Z" />
                          <path d="M17.5,19h-16A1.54,1.54,0,0,1,0,17.5v-16A1.54,1.54,0,0,1,1.53,0h16A1.54,1.54,0,0,1,19,1.53v16A1.54,1.54,0,0,1,17.5,19ZM1.53.25A1.29,1.29,0,0,0,.25,1.53v16a1.28,1.28,0,0,0,1.28,1.28h16a1.28,1.28,0,0,0,1.28-1.28v-16A1.28,1.28,0,0,0,17.5.25Zm16,17.84h-9V8.45h9.64V17.5a.59.59,0,0,1-.59.59Zm-8.8-.25h8.8a.34.34,0,0,0,.34-.34V8.7H8.7Zm-7.17.25a.59.59,0,0,1-.59-.59v-.12h0V1.53a.6.6,0,0,1,.6-.59H7.76V18.09H1.53Zm-.34-.54a.35.35,0,0,0,.34.29h6V1.19h-6a.35.35,0,0,0-.35.34Zm16.9-9.79H8.45V.94H17.5a.6.6,0,0,1,.58.47h0V7.76ZM8.7,7.51h9.14v-6a.34.34,0,0,0-.34-.34H8.7Z" />
                        </g>
                      </svg>
                    </div>
                  </button>
                </div>
              :
                ''
            }
            {
              this.props.type === 'wbt' ?
                <div className="quick-actions-item">
                  <button
                    className="quick-action-button comments"
                    onClick={this.toggleComments.bind(this)}
                  >
                    <div className="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17.779" viewBox="0 0 20 17.779">
                        <g id="Gruppe_2049" data-name="Gruppe 2049" transform="translate(-292.637 -560.047)">
                          <path id="Pfad_1133" data-name="Pfad 1133" d="M330.389,561.922c0-.007,0-.014,0-.021a1.864,1.864,0,0,0-.65-1.4,1.932,1.932,0,0,0-1.22-.454c-.141,0-.281,0-.423,0h-11.36a1.92,1.92,0,0,0-1.22.454,1.892,1.892,0,0,0-.651,1.49v13.627c0,.11,0,.22,0,.33a1.869,1.869,0,0,0,1.869,1.869c.45,0,.9,0,1.352,0h9.512a3.424,3.424,0,0,0,1.92-.287,1.906,1.906,0,0,0,.863-1.419,2.44,2.44,0,0,0,.009-.263V562.007l-.007.118C330.386,562,330.389,561.922,330.389,561.922Zm-.978.957v12.1a2.135,2.135,0,0,1-.008.23,1.667,1.667,0,0,1-.755,1.24,2.992,2.992,0,0,1-1.678.251h-8.315c-.4,0-.789,0-1.182,0a1.634,1.634,0,0,1-1.634-1.634c0-.1,0-.192,0-.289V562.866a1.654,1.654,0,0,1,.569-1.3,1.679,1.679,0,0,1,1.066-.4h9.931c.124,0,.246,0,.37,0a1.686,1.686,0,0,1,1.067.4,1.629,1.629,0,0,1,.568,1.223c0,.006,0,.012,0,.018s0,.066-.008.178Z" transform="translate(-17.752 0)" fill="#fff" style={{fill: '#fff'}}/>
                          <path id="Pfad_1134" data-name="Pfad 1134" d="M329.13,577.722h7.737c.358,0,.717.008,1.075,0h.014a.59.59,0,1,0,0-1.179h-7.737c-.358,0-.717-.008-1.076,0h-.014a.59.59,0,1,0,0,1.179Z" transform="translate(-28.677 -13.173)" fill="#fff" style={{fill: '#fff'}}/>
                          <path id="Pfad_1135" data-name="Pfad 1135" d="M347.31,593.03h-6.47a.59.59,0,0,0,0,1.179h6.47a.59.59,0,0,0,0-1.179Z" transform="translate(-38.031 -26.345)" fill="#fff" style={{fill: '#fff'}}/>
                          <path id="Pfad_1136" data-name="Pfad 1136" d="M359.8,609.5h-3.323a.59.59,0,0,0,0,1.179H359.8a.59.59,0,1,0,0-1.179Z" transform="translate(-50.521 -39.496)" fill="#fff" style={{fill: '#fff'}}/>
                          <path id="Pfad_1137" data-name="Pfad 1137" d="M362.921,625.971h-2.537a.59.59,0,0,0,0,1.179h2.537a.59.59,0,1,0,0-1.179Z" transform="translate(-53.642 -52.657)" fill="#fff" style={{fill: '#fff'}}/>
                          <g id="Gruppe_2047" data-name="Gruppe 2047" transform="translate(292.637 563.094)">
                            <path id="Pfad_1138" data-name="Pfad 1138" d="M305.214,585.649a1.676,1.676,0,0,1,.059.423l.005.085c.014.182.018.361.023.551l0,.083c0,.225,0,.454,0,.682v.108c0,.1,0,.208,0,.289l-.285,0c-.322,0-.747,0-1.179-.023l-.106,0a1.336,1.336,0,0,1-.855-.207c-.256-.249-.511-.506-.764-.762l-.38-.383-2.139-2.139c-.232-.232-.468-.46-.7-.689-.456-.441-.927-.9-1.356-1.371-.1-.113-.233-.237-.372-.368a7.648,7.648,0,0,1-.583-.6l-.015-.018-.035-.032-.007-.006-1.677-1.677-.03-.027-.05-.068a.635.635,0,0,1,.059-.828c.058-.061.118-.119.177-.178l.979-.979c.053-.053.1-.1.15-.146l0,0a.751.751,0,0,1,.132-.1l.074-.042a.574.574,0,0,1,.209-.04.71.71,0,0,1,.46.185l.114.1,1.563,1.563c.39.39.777.777,1.165,1.168l3.4,3.4q.29.29.582.579c.412.409.839.832,1.249,1.254a.441.441,0,0,1,.115.19" transform="translate(-294.239 -576.784)" fill="#142847" style={{fill: '#142847'}}/>
                            <path id="Pfad_1139" data-name="Pfad 1139" d="M303.233,584.187a1.6,1.6,0,0,1,.037.312l.006.1c.013.168.017.343.022.527l0,.076c0,.224,0,.448,0,.671-.3,0-.674,0-1.044-.022l-.11-.005a1.436,1.436,0,0,1-.589-.092c-.253-.246-.51-.505-.758-.755-.128-.129-.256-.258-.384-.386l-2.139-2.139c-.235-.235-.475-.468-.707-.693-.472-.457-.918-.889-1.339-1.353-.113-.125-.249-.254-.393-.39a7.355,7.355,0,0,1-.552-.562l-.03-.036-.034-.032-.028-.025-1.483-1.483-.091-.091-.091-.091-.009-.009,0,0-.011-.014-.017-.022a.233.233,0,0,1,.026-.312c.055-.057.112-.113.168-.169l.1-.1.891-.891c.041-.041.082-.083.125-.122l.008-.007a.368.368,0,0,1,.058-.046l.043-.024a.159.159,0,0,1,.044-.006h0Zm-8.282-9a.989.989,0,0,0-.5.138l.023-.006a1.141,1.141,0,0,0-.205.152h0c-.057.052-.112.107-.167.162l-.885.885c-.092.092-.186.182-.276.276a1.035,1.035,0,0,0-.1,1.34c.007.012.017.022.025.033.021.027.039.056.062.082s.025.021.037.032l.182.182,1.513,1.513.016.013c.32.38.735.722.965.975.657.724,1.383,1.383,2.073,2.073l2.139,2.139c.382.382.762.773,1.15,1.15a1.8,1.8,0,0,0,1.222.324c.4.018.8.023,1.2.023l.293,0c.4,0,.4-.054.4-.692,0-.267,0-.533,0-.8-.005-.217-.009-.435-.026-.651a2.313,2.313,0,0,0-.087-.616l0,.014a.841.841,0,0,0-.215-.368c-.6-.622-1.224-1.226-1.835-1.838l-1.455-1.455-1.948-1.948c-.414-.417-.827-.83-1.244-1.247l-1.223-1.223-.38-.38h-.017a1.111,1.111,0,0,0-.724-.284Z" transform="translate(-292.637 -575.186)" fill="#fff" style={{fill: '#fff'}}/>
                          </g>
                          <g id="Gruppe_2048" data-name="Gruppe 2048" transform="translate(294.444 564.936)">
                            <rect id="Rechteck_422" data-name="Rechteck 422" width="2.924" height="0.805" transform="translate(0 2.068) rotate(-45)" fill="#fff" style={{fill: '#fff'}}/>
                          </g>
                        </g>
                      </svg>
                    </div>
                    {
                      this.props.totalOpenComments > 0 ?
                        <div className="count">{this.props.totalOpenComments}</div>
                      :
                        null
                    }
                  </button>
                  {
                    this.state.comments ?
                      <div className="quick-actions-window">
                        <div className="headline">Aufgaben</div>
                        <ul className="comments">
                          {
                            this.props.comments.map((comment, index) => {
                              if(!comment.checked) {
                                return(
                                  <li
                                    key={index}
                                  >
                                    <button
                                      onClick={this.handleSelectComment.bind(this, comment.element_id)}
                                    >
                                      <span className="label">{comment.comment}</span>
                                      <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14">
                                          <g id="visibility" transform="translate(0 -106.662)">
                                            <g id="Gruppe_992" data-name="Gruppe 992" transform="translate(0 106.662)">
                                              <g id="Gruppe_991" data-name="Gruppe 991" transform="translate(0 0)">
                                                <path id="Pfad_841" data-name="Pfad 841" d="M23.911,113.378c-.189-.275-4.731-6.716-11.911-6.716-6.161,0-11.651,6.4-11.882,6.677a.5.5,0,0,0,0,.646c.231.273,5.721,6.677,11.882,6.677s11.651-6.4,11.882-6.677A.5.5,0,0,0,23.911,113.378ZM12,119.662c-4.939,0-9.635-4.71-10.828-6,1.191-1.291,5.882-6,10.828-6,5.779,0,9.858,4.7,10.854,5.973C21.7,114.884,16.981,119.662,12,119.662Z" transform="translate(0 -106.662)" fill="#fff"/>
                                              </g>
                                            </g>
                                            <g id="Gruppe_994" data-name="Gruppe 994" transform="translate(7.816 109.478)">
                                              <g id="Gruppe_993" data-name="Gruppe 993" transform="translate(0 0)">
                                                <path id="Pfad_842" data-name="Pfad 842" d="M174.846,170.662a4.184,4.184,0,1,0,4.184,4.184A4.188,4.188,0,0,0,174.846,170.662Zm0,7.322a3.138,3.138,0,1,1,3.138-3.138A3.142,3.142,0,0,1,174.846,177.984Z" transform="translate(-170.662 -170.662)" fill="#fff"/>
                                              </g>
                                            </g>
                                          </g>
                                        </svg>
                                      </span>
                                    </button>
                                  </li>
                                )
                              } else {
                                return null
                              }
                            })
                          }
                        </ul>
                      </div>
                    :
                      null
                  }
                </div>
              :
                ''
            }
            <Link
              to="/hilfe"
              target="_blank"
            >
              <button className="quick-action-button help">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <defs>
                      <linearGradient id="linear-gradient" x2="1" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#be00c4"/>
                        <stop offset="1" stopColor="#a200dc"/>
                      </linearGradient>
                    </defs>
                    <g transform="translate(-864 -21)">
                      <circle cx="11" cy="11" r="11" transform="translate(864 21)" fill="url(#linear-gradient)"/>
                      <text transform="translate(872 36)" fill="#fff" fontSize="12" fontFamily="DIN2014-Regular, 'DIN 2014'" letterSpacing="0.08em"><tspan x="0" y="0">?</tspan></text>
                    </g>
                  </svg>
                </div>
              </button>
            </Link>
          </div>
          <div className="button-group primary">
            <button
              className={'button round transparent save ' + (this.props.isSaved ? ' saved' : '')}
              onClick={this.props.onSave}
            >
              <span className="label">Speichern</span>
            </button>
            {
              this.props.type === 'wbt' ?
                <button
                  className="button highlighted export"
                  onClick={this.props.onOpenExport}
                >
                  <span className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.041" height="18" viewBox="0 0 19.041 18">
                      <path id="np_export_1179540_000000" d="M37.7,27.3l4.77,4.831a.817.817,0,1,1-1.154,1.157L38.1,30.063c-.157-.158-.286-.1-.286.121v8.9a.817.817,0,1,1-1.633,0v-8.9c0-.225-.128-.28-.286-.121l-3.217,3.225a.817.817,0,1,1-1.154-1.157l4.74-4.826a1,1,0,0,1,1.437,0Zm6.66,16.695V41.131a.818.818,0,0,1,1.636,0v3.683a1.228,1.228,0,0,1-1.23,1.226H29.231A1.231,1.231,0,0,1,28,44.814V41.131a.818.818,0,0,1,1.636,0v2.864a.411.411,0,0,0,.409.409H43.955a.412.412,0,0,0,.409-.409Z" transform="translate(46.04 -28) rotate(90)" fillRule="evenodd" />
                    </svg>
                  </span>
                  <span className="label">Export</span>
                </button>
              :
                ''
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Header
